/**
 * 新しいプロジェクトの作成（pages/ProjectsPage.tsx）で、スラッグが使用済みのときの「空いている候補」を取り出す（2026-09-27 cli-init-keys）。
 * React から切り離した純関数（node --test で確かめる・slugSuggestions.test.ts）。
 *
 * API の正: apps/server/src/modules/platform/routes.ts の POST /v1/projects。
 *   409 { error: { code: 'slug_taken', message, details: { slug, suggestions: [...] } } }
 *   400 { error: { code: 'slug_reserved', message, details: { slug, suggestions: [...] } } }（Core の統合⑰・SEC-R3-04）
 *     = www・api・admin・login・customers・bounce など運用の名前や kumo を含む名前（予約語）。details は slug_taken と同じ形
 *   suggestions = 確かめた時点で空いている最大 3 つ（空の配列もある = サーバーの候補の確認が失敗したとき）。候補に予約語は出ない。
 *
 * WHY 画面に候補を出すか: 以前は「このURLスラッグはすでに使われています。別のものを指定してください」だけで、
 *   人が当てずっぽうに打ち直していた。空いている候補をボタンで出し、押せばスラッグの欄に入る（送信は本人が押す =
 *   名前は URL に出るので、勝手に作らない。CLI は既定のスラッグなら自動で作り直すが、画面は欄が目の前にあるので選ばせる）。
 */

/** サーバーと同じ規則（slugSuggestions.ts の SLUG_RE: 3〜58 文字・英小文字と数字・単独のハイフン・"--" 禁止） */
const SLUG_RE = /^(?!.*--)[a-z0-9](?:[a-z0-9-]{1,56}[a-z0-9])$/;

/** 画面に並べる上限。サーバーは 3 つ返す。多すぎる応答が来てもボタンを並べすぎない */
const MAX_SHOWN = 3;

/**
 * エラーから候補を取り出す。409 slug_taken / 400 slug_reserved 以外・details の形が違う・規則に合わない値は捨てる（壊れた応答でも画面を壊さない）。
 * 重複も落とす（同じボタンが 2 つ並ばないように）。状態コードとコードの組で見る = 別の意味の 400 に同じ名前のコードが来ても拾わない
 */
export function slugSuggestionsFrom(err: { status?: number; code?: string; details?: Record<string, unknown> } | null | undefined): string[] {
  if (!err) return [];
  const known = (err.status === 409 && err.code === 'slug_taken') || (err.status === 400 && err.code === 'slug_reserved');
  if (!known) return [];
  const list = err.details?.suggestions;
  if (!Array.isArray(list)) return [];
  const out: string[] = [];
  for (const s of list) {
    if (typeof s === 'string' && SLUG_RE.test(s) && !out.includes(s)) out.push(s);
    if (out.length >= MAX_SHOWN) break;
  }
  return out;
}
